import { Person } from "../calorie-calculation/Person"
import {SleepCalorieConsumption, WorkCalorieConsumption , SportCalorieConsumption } from "@/util/calorie-calculation/CalorieConsumption"
import {DailyCalorieConsumption} from "@/util/calorie-calculation/DailyCalorieConsumption"
import {Shake} from "./Shake"
import base from "@/calorie-table/caloryTable.json"
import {Addon} from "./Addon"
import ingredients from '@/calorie-table/ingredients.json'



export class Barkeeper{
    constructor(answers){
        this._answers = answers
        this._base = base
        this._ingredients = ingredients
    }

    get answers () {
        return this._answers
    }

    get person () {
        return new Person(this._answers['gender'], this._answers['birthday'], this._answers['weight'], this._answers['height'])
    }
    
    get workCalories () {
        return new WorkCalorieConsumption(this.person, this.answers['jobHours'])
    }
    
    get sleepCalories () {
        return new SleepCalorieConsumption(this.person, this.answers['sleep'])
    }
    
    get sportCalories () {
        return new SportCalorieConsumption(this.person, this.answers['sportMinutes'], this.answers['sport'], this.answers['sportIntensity'])
    }
    
    get dailyCalories () {
        let daily = new DailyCalorieConsumption(this.person)
        daily.addCalorieConsumption(this.workCalories)
        daily.addCalorieConsumption(this.sleepCalories)
        daily.addCalorieConsumption(this.sportCalories)

        return this.answers['calorieKnown'] && this.answers['calorieManual'] ? parseInt(this.answers['calorieManual']) : daily.calcCalories
    }
    
    get caloriesPerPortion () {
        return (this.dailyCalories / 3).toFixed(1) || 0
    }

    get roundPortion () {
        let val = Math.ceil(this.caloriesPerPortion / 50)*50
        if (val < 500) {
            return 500
        }
        if (val > 1000) {
            return 1000
        }
        return val
    }

    get type () {
        let proteinCounter = 0
        this.answers['question1'] === 'protein' ? proteinCounter += 1 : proteinCounter += 0
        this.answers['question2'] === 'protein' ? proteinCounter += 1 : proteinCounter += 0
        this.answers['question3'] === 'protein' ? proteinCounter += 1 : proteinCounter += 0
        this.answers['question4'] === 'protein' ? proteinCounter += 1 : proteinCounter += 0
        
        return proteinCounter >= 3 ? 'protein' : 'carbohydrate'
    }

    get ingredients () {
        return this._ingredients
    }

    addIngredient (ingredient) {
        if (!this.ingredients.includes(ingredient)) {
            this._ingredients.push(ingredient)
        }
    }

    get mixShake() {
        let addons = []
        if (this.answers['deficit'].includes('vitaminB12')) {
            addons.push(new Addon('vitaminB12', {
                calories: 4,
                carbohydrate: 0.8,
                sugar: 0.02,
                fiber: 0.04,
                fat: 0.02,
                protein: 0.1,
                fattyAcids: {
                    saturatedFattyAcids: 0.002
                },
                vitamins: {
                    b1: 1.6,
                    b2: 2.6,
                    b3: 28,
                    b5: 11,
                    b6: 1.5,
                    b9: 344,
                    b12: 3.6,
                    h: 100
                }
            }, 70))
        }
        if (this.answers['deficit'].includes('zinc')) {
            addons.push(new Addon('zincDeficit', {
                traceElements: {
                    zinc: 4.5
                }
            }, 45))
        }
        if (this.answers['deficit'].includes('iron')) {
            addons.push(new Addon('ironDeficit', {
                traceElements: {
                    iron: 10
                }
            }, 55))
        }
        if (this.answers['zinc']) {
            addons.push(new Addon('zincQuestion', {
                traceElements: {
                    zinc: ['=', 5]
                }
            }))
        }
        if (this.answers['milk'] && this.answers['milkamount']) {
            let am = this.answers['milkamount'] > 7 ? 7 : this.answers['milkamount']
            addons.push(new Addon('milk', {
                minerals: {
                    calcium: -100*am
                }
            }))
        }
        if (this.answers['habit'].includes('smoking')) {
            addons.push(new Addon('smoking', {
                calories: 5.12,
                carbohydrate: 0.9699,
                sugar: 0.014,
                fiber: 0.028,
                fat: 0.0404,
                protein: 0.0941,
                fattyAcids: {
                    saturatedFattyAcids: 0.0076,
                    monoUnsaturatedFattyAcids: 0.0045,
                    multipleUnsaturatedFattyAcids: 0.0105
                },
                vitamins: {
                    b1: 1.12,
                    b2: 1.86,
                    b3: 19.6,
                    b5: 7.7,
                    b6: 1.05,
                    b9: 240.8,
                    b12: 2.52,
                    h: 70
                },
                essentialAminoAcids: {
                    cysteine: 0.11,
                    histidine: 0.34,
                    isoleucine: 0.69,
                    leucine: 1.26,
                    lysine: 1.26,
                    methionine: 0.23,
                    phenylalanine: 0.57,
                    threonine: 0.69,
                    tryptophan: 0.23,
                    valine: 0.8
                },
                noEssentialAminoAcids: {
                    alanine: 1.03,
                    arginine: 0.8,
                    asparticAcid: 1.03
                }
            }, 219))
        }
        if (this.answers['detox3']) {
            this.addIngredient('Pinienrindenextrakt')
            addons.push(new Addon('antioxidanzien', {
                calories: 2.32,
                carbohydrate: 0.4099,
                fat: 0.0264,
                protein: 0.0241,
                fattyAcids: {
                    saturatedFattyAcids: 0.0062,
                    monoUnsaturatedFattyAcids: 0.0045,
                    multipleUnsaturatedFattyAcids: 0.0105
                },
                essentialAminoAcids: {
                    cysteine: 0.11,
                    histidine: 0.34,
                    isoleucine: 0.69,
                    leucine: 1.26,
                    lysine: 1.26,
                    methionine: 0.23,
                    phenylalanine: 0.57,
                    threonine: 0.69,
                    tryptophan: 0.23,
                    valine: 0.8
                },
                noEssentialAminoAcids: {
                    alanine: 1.03,
                    arginine: 0.8,
                    asparticAcid: 1.03
                }
            }, 133))
        }
        if (this.answers['detox2']) {
            this.addIngredient('Astragaluswurzel')
            this.addIngredient('Resveratrol')
            this.addIngredient('Matcha Grünteeextrakt')
            addons.push(new Addon('DNAMultiprotect', {}, 197))
        }
        if (this.answers['detox1']) {
            this.addIngredient('MSM')
            this.addIngredient('Mariendistelextrakt')
            this.addIngredient('Bentonit')

            addons.push(new Addon('Entgiftungspaket', {}, 210))
        }
        if (this.answers['detox4']) {
            this.addIngredient('Ginkgo Biloba')
            this.addIngredient('Sibirischer Ginseng')
            addons.push(new Addon('Leistungspaket', {}, 73))  // Price not known yet
        }
        if (this.answers['deficit'].includes('vitaminD')) {
            addons.push(new Addon('vitaminD', {
                vitamins: {
                    d: ['=', 30],
                }
            }, 60))
        }
        /*if (this.answers['deficit'].includes('calcium')) {
            this._addons.push(new Addon('calcium', {
                minerals: {
                    calcium: ?,
                }
            }, 103))
        }*/
        if (!this.answers['fish']) {
            addons.push(new Addon('fish', {
                traceElements: {
                    iodine: -50
                },
            }))
        }
        if (!this.answers['salt']) {
            addons.push(new Addon('salt', {
                traceElements: {
                    iodine: -50
                },
            }))
        }
        if ((!this.answers['salt'] && this.answers['eatHabit'].includes('vegan')) || (!this.answers['salt'] && !this.answers['fish'])) {
            addons.push(new Addon('fattyAcids', {
                fattyAcids: {
                    omega3: 2
                }
            }))
        }
        if (this.answers['nuts'] && this.answers['nutsamount']) {
            let nut = this.answers['nutsamount']
            addons.push(new Addon('nuts', {
                traceElements: {
                    selenium: nut >= 21 ? ['=', 0] : -(nut*30/14)
                }
            }))
        }
        return new Shake(base[this.person.gender][this.type][this.roundPortion], addons)
    }


}